const languages = [
  // Abkhazian
  'ab',
  // Afar
  'aa',
  // Afrikaans
  'af',
  // Albanian
  'sq',
  // Amharic
  'am',
  // Arabic
  'ar',
  // Armenian
  'hy',
  // Assamese
  'as',
  // Aymara
  'ay',
  // Azerbaijani
  'az',
  // Bashkir
  'ba',
  // Basque
  'eu',
  // Bengali, Bangla
  'bn',
  // Bhutani
  'dz',
  // Bihari
  'bh',
  // Bislama
  'bi',
  // Breton
  'br',
  // Bulgarian
  'bg',
  // Burmese
  'my',
  // Byelorussian
  'be',
  // Cambodian
  'km',
  // Catalan
  'ca',
  // Chinese
  'zh',
  // Corsican
  'co',
  // Croatian
  'hr',
  // Czech
  'cs',
  // Danish
  'da',
  // Dutch
  'nl',
  // English, American
  'en',
  // Esperanto
  'eo',
  // Estonian
  'et',
  // Faeroese
  'fo',
  // Fiji
  'fj',
  // Finnish
  'fi',
  // French
  'fr',
  // Frisian
  'fy',
  // Gaelic (Scots Gaelic)
  'gd',
  // Galician
  'gl',
  // Georgian
  'ka',
  // German
  'de',
  // Greek
  'el',
  // Greenlandic
  'kl',
  // Guarani
  'gn',
  // Gujarati
  'gu',
  // Hausa
  'ha',
  // Hebrew
  'iw',
  // Hindi
  'hi',
  // Hungarian
  'hu',
  // Icelandic
  'is',
  // Indonesian
  'in',
  // Interlingua
  'ia',
  // Interlingue
  'ie',
  // Inupiak
  'ik',
  // Irish
  'ga',
  // Italian
  'it',
  // Japanese
  'ja',
  // Javanese
  'jw',
  // Kannada
  'kn',
  // Kashmiri
  'ks',
  // Kazakh
  'kk',
  // Kinyarwanda
  'rw',
  // Kirghiz
  'ky',
  // Kirundi
  'rn',
  // Korean
  'ko',
  // Kurdish
  'ku',
  // Laothian
  'lo',
  // Latin
  'la',
  // Latvian, Lettish
  'lv',
  // Lingala
  'ln',
  // Lithuanian
  'lt',
  // Macedonian
  'mk',
  // Malagasy
  'mg',
  // Malay
  'ms',
  // Malayalam
  'ml',
  // Maltese
  'mt',
  // Maori
  'mi',
  // Marathi
  'mr',
  // Moldavian
  'mo',
  // Mongolian
  'mn',
  // Nauru
  'na',
  // Nepali
  'ne',
  // Norwegian
  'no',
  // Occitan
  'oc',
  // Oriya
  'or',
  // Oromo, Afan
  'om',
  // Pashto, Pushto
  'ps',
  // Persian
  'fa',
  // Polish
  'pl',
  // Portuguese
  'pt',
  // Punjabi
  'pa',
  // Quechua
  'qu',
  // Rhaeto-Romance
  'rm',
  // Romanian
  'ro',
  // Russian
  'ru',
  // Samoan
  'sm',
  // Sangro
  'sg',
  // Sanskrit
  'sa',
  // Serbian
  'sr',
  // Serbo-Croatian
  'sh',
  // Sesotho
  'st',
  // Setswana
  'tn',
  // Shona
  'sn',
  // Sindhi
  'sd',
  // Singhalese
  'si',
  // Siswati
  'ss',
  // Slovak
  'sk',
  // Slovenian
  'sl',
  // Somali
  'so',
  // Spanish
  'es',
  // Sudanese
  'su',
  // Swahili
  'sw',
  // Swedish
  'sv',
  // Tagalog
  'tl',
  // Tajik
  'tg',
  // Tamil
  'ta',
  // Tatar
  'tt',
  // Tegulu
  'te',
  // Thai
  'th',
  // Tibetan
  'bo',
  // Tigrinya
  'ti',
  // Tonga
  'to',
  // Tsonga
  'ts',
  // Turkish
  'tr',
  // Turkmen
  'tk',
  // Twi
  'tw',
  // Ukrainian
  'uk',
  // Urdu
  'ur',
  // Uzbek
  'uz',
  // Vietnamese
  'vi',
  // Volapuk
  'vo',
  // Welsh
  'cy',
  // Wolof
  'wo',
  // Xhosa
  'xh',
  // Yiddish
  'ji',
  // Yoruba
  'yo',
  // Zulu
  'zu'
];

const languageNames = {
  ab: 'Abkhazian',
  aa: 'Afar',
  af: 'Afrikaans',
  sq: 'Albanian',
  am: 'Amharic',
  ar: 'Arabic',
  hy: 'Armenian',
  as: 'Assamese',
  ay: 'Aymara',
  az: 'Azerbaijani',
  ba: 'Bashkir',
  eu: 'Basque',
  bn: 'Bengali, Bangla',
  dz: 'Bhutani',
  bh: 'Bihari',
  bi: 'Bislama',
  br: 'Breton',
  bg: 'Bulgarian',
  my: 'Burmese',
  be: 'Byelorussian',
  km: 'Cambodian',
  ca: 'Catalan',
  zh: 'Chinese',
  co: 'Corsican',
  hr: 'Croatian',
  cs: 'Czech',
  da: 'Danish',
  nl: 'Dutch',
  en: 'English, American',
  eo: 'Esperanto',
  et: 'Estonian',
  fo: 'Faeroese',
  fj: 'Fiji',
  fi: 'Finnish',
  fr: 'French',
  fy: 'Frisian',
  gd: 'Gaelic (Scots Gaelic)',
  gl: 'Galician',
  ka: 'Georgian',
  de: 'German',
  el: 'Greek',
  kl: 'Greenlandic',
  gn: 'Guarani',
  gu: 'Gujarati',
  ha: 'Hausa',
  iw: 'Hebrew',
  hi: 'Hindi',
  hu: 'Hungarian',
  is: 'Icelandic',
  in: 'Indonesian',
  ia: 'Interlingua',
  ie: 'Interlingue',
  ik: 'Inupiak',
  ga: 'Irish',
  it: 'Italian',
  ja: 'Japanese',
  jw: 'Javanese',
  kn: 'Kannada',
  ks: 'Kashmiri',
  kk: 'Kazakh',
  rw: 'Kinyarwanda',
  ky: 'Kirghiz',
  rn: 'Kirundi',
  ko: 'Korean',
  ku: 'Kurdish',
  lo: 'Laothian',
  la: 'Latin',
  lv: 'Latvian, Lettish',
  ln: 'Lingala',
  lt: 'Lithuanian',
  mk: 'Macedonian',
  mg: 'Malagasy',
  ms: 'Malay',
  ml: 'Malayalam',
  mt: 'Maltese',
  mi: 'Maori',
  mr: 'Marathi',
  mo: 'Moldavian',
  mn: 'Mongolian',
  na: 'Nauru',
  ne: 'Nepali',
  no: 'Norwegian',
  oc: 'Occitan',
  or: 'Oriya',
  om: 'Oromo, Afan',
  ps: 'Pashto, Pushto',
  fa: 'Persian',
  pl: 'Polish',
  pt: 'Portuguese',
  pa: 'Punjabi',
  qu: 'Quechua',
  rm: 'Rhaeto-Romance',
  ro: 'Romanian',
  ru: 'Russian',
  sm: 'Samoan',
  sg: 'Sangro',
  sa: 'Sanskrit',
  sr: 'Serbian',
  sh: 'Serbo-Croatian',
  st: 'Sesotho',
  tn: 'Setswana',
  sn: 'Shona',
  sd: 'Sindhi',
  si: 'Singhalese',
  ss: 'Siswati',
  sk: 'Slovak',
  sl: 'Slovenian',
  so: 'Somali',
  es: 'Spanish',
  su: 'Sudanese',
  sw: 'Swahili',
  sv: 'Swedish',
  tl: 'Tagalog',
  tg: 'Tajik',
  ta: 'Tamil',
  tt: 'Tatar',
  te: 'Tegulu',
  th: 'Thai',
  bo: 'Tibetan',
  ti: 'Tigrinya',
  to: 'Tonga',
  ts: 'Tsonga',
  tr: 'Turkish',
  tk: 'Turkmen',
  tw: 'Twi',
  uk: 'Ukrainian',
  ur: 'Urdu',
  uz: 'Uzbek',
  vi: 'Vietnamese',
  vo: 'Volapuk',
  cy: 'Welsh',
  wo: 'Wolof',
  xh: 'Xhosa',
  ji: 'Yiddish',
  yo: 'Yoruba',
  zu: 'Zulu'
};

module.exports = languageNames



// WEBPACK FOOTER //
// ./src/common/utils/languageValidator.js